<div class="left-sidenav tpo-report-card" id="{{uniqueId}}" [class.disclosures-processing]="disclosuresPending">
  @let basePath = '/tpo/app-details/' + loanId;
  <div class="menu-content h-100">
    <ul class="left-sidenav-menu sticky">
      <li (click)="onListItemClicked($event, 'loan-summary')" class="tpo-parent-menu-item"
        [hidden]="disabledTpoAppMenuItems?.includes('LoanSummary')" [ngClass]="{'mm-active': tab === 'loan-summary'}">
        <a
          [routerLink]="isCompanyPulseProcessing ? [basePath + '/tpo-loan-summary'] : [basePath + '/loan-summary']">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <span>Loan Summary</span>
        </a>
      </li>
      @let isUrlaActive = isUrlaExpanded || tab === 'urla';
      <li class="tpo-parent-menu-item" [ngClass]="{'mm-active': isUrlaActive}"
        [hidden]="disabledTpoAppMenuItems?.includes('Urla')">
        <a [routerLink]="[basePath + '/urla']" [attr.aria-expanded]="isUrlaExpanded"
          (click)="toggleMenuExpansion('urla')">
          <span>
            <i class="status-indicator pi"
              [ngClass]="{
                'pi-check-circle text-success': urlaStatus === MenuItemStatus.Success,
                'pi-question-circle text-warning': !urlaStatus || urlaStatus === MenuItemStatus.None || urlaStatus === MenuItemStatus.Pending,
                'pi-times-circle text-danger': urlaStatus === MenuItemStatus.Error,
                'pi-spin pi-spinner': urlaStatus === MenuItemStatus.Loading
              }"></i>
          </span>
          <span>URLA 2020</span>
          <i class="ms-auto fa-solid text-muted" style="font-size: 0.7rem;" [ngClass]="isUrlaExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
        </a>
        <ul class="nav-second-level mm-collapse" aria-expanded="false"
          [ngClass]="{'mm-show': isUrlaExpanded}">
          @if (tab === 'urla') {
          <urla-menu (menuItemClicked)='onMenuItemClicked($event)'></urla-menu>
          }
        </ul>
      </li>
      @let isServicesActive = activeMenuId === 'services';
      <li class="has-section-toggle"
        [hidden]="!featurePermissions.isServicesEnabled || isCompanyPulseProcessing || isCompanySmartfi || disabledTpoAppMenuItems?.includes('Services')"
        [ngClass]="{'mm-sub-active': isServicesActive}">
        <a href="javascript: void(0);" [attr.aria-expanded]="isServicesExpanded" (click)="toggleMenuExpansion('services')">
          <span>
            <i class="status-indicator pi pi-question-circle text-warning"></i>
          </span>
          <span>Services</span>
          <i class="ms-auto fa-solid fa-chevron-right text-muted section-toggle-icon" style="font-size: 0.7rem;" [class.is-open]="isServicesExpanded" aria-hidden="true"></i>
        </a>
        <button type="button" class="section-toggle" [attr.aria-expanded]="isServicesExpanded"
          aria-label="Services submenu" (click)="toggleMenuExpansion('services')"></button>
        <ul class="nav-second-level mm-collapse" aria-expanded="false"
          [ngClass]="{'mm-show': isServicesExpanded}">
          <menu-item [hidden]="!featurePermissions.isCreditAllowed || disabledTpoAppMenuItems?.includes('Credit')"
            [label]="isServiceNotReady(LoanServiceType.Credit) ? 'Credit ⚠' : 'Credit'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/credit-reports'" [isActive]="tab === 'credit-reports'" [status]="MenuItemStatus.Pending" [id]="'credit'"
            [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!featurePermissions.isVoiVoeAllowed || disabledTpoAppMenuItems?.includes('VoiVoe')"
            [label]="isServiceNotReady(LoanServiceType.VoiVoe) ? 'VOI/VOE ⚠' : 'VOI/VOE'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/digital-emp-income-verification'" [isActive]="tab === 'digital-emp-income-verification'" [status]="MenuItemStatus.Pending"
            [id]="'voi-voe'" [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!featurePermissions.isVoaAllowed || disabledTpoAppMenuItems?.includes('Voa')"
            [label]="isServiceNotReady(LoanServiceType.Voa) ? 'VOA ⚠' : 'VOA'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/digital-asset-verification'" [isActive]="tab === 'digital-asset-verification'" [status]="MenuItemStatus.Pending" [id]="'voa'"
            [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!featurePermissions.isAusAllowed || disabledTpoAppMenuItems?.includes('Aus')"
            [label]="isServiceNotReady(LoanServiceType.Aus) ? 'AUS ⚠' : 'AUS'" (menuItemClicked)="onMenuItemClicked($event)" [link]="basePath + '/aus'" [isActive]="tab === 'aus'"
            [status]="MenuItemStatus.Pending" [id]="'aus'" [groupId]="'services'">
          </menu-item>
          <menu-item class="disclosures-menu-item"
            [hidden]="(disclosuresEnabled && !featurePermissions.isDisclosureGenerationAllowed) || disabledTpoAppMenuItems?.includes('Disclosures')"
            [label]="isServiceNotReady(LoanServiceType.Disclosures) ? (applicationContext.isCompanyPRMG ? 'Send Disclosures ⚠' : 'Disclosures ⚠') : (applicationContext.isCompanyPRMG ? 'Send Disclosures' : 'Disclosures')" (menuItemClicked)="onMenuItemClicked($event)" [isActive]="tab === 'disclosures'"
            [link]="basePath + '/disclosures'" [status]="MenuItemStatus.Pending" [id]="'disclosures'"
            [groupId]="'services'">
          </menu-item>
          <menu-item
            [hidden]="(!featurePermissions.isAppraisalOrderAllowed || (isCompanyPRMG && (applicationContext?.application?.channel === 'Correspondent' || applicationContext?.application?.channel === 'NonDelegatedCorrespondent'))) || disabledTpoAppMenuItems?.includes('Appraisal')"
            [label]="isServiceNotReady(LoanServiceType.Appraisal) ? 'Appraisal ⚠' : 'Appraisal'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/appraisal'" [isActive]="tab === 'appraisal'" [status]="MenuItemStatus.Pending" [id]="'appraisal'"
            [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!featurePermissions.isLinkEnabled || disabledTpoAppMenuItems?.includes('Link')"
            [label]="isServiceNotReady(LoanServiceType.Link) ? 'LINK ⚠' : 'LINK'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/link'" [isActive]="tab === 'link'" [status]="MenuItemStatus.Pending" [id]="'link'" [groupId]="'services'">
          </menu-item>
          <menu-item
            [hidden]="!featurePermissions.isLinkCalculatorEnabled || disabledTpoAppMenuItems?.includes('LinkIncomeCalc')"
            [label]="isServiceNotReady(LoanServiceType.LinkIncomeCalc) ? 'LINK Income Calculator ⚠' : 'LINK Income Calculator'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/link-income-calculator'" [isActive]="tab === 'link-income-calculator'" [status]="MenuItemStatus.Pending"
            [id]="'link-income-calc'" [groupId]="'services'">
          </menu-item>
          <menu-item
            [hidden]="!featurePermissions.isIncomeAnalysisEnabled || disabledTpoAppMenuItems?.includes('IncomeAnalysis')"
            [label]="'Income Analysis'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/income-analysis'" [isActive]="tab === 'income-analysis'" [status]="MenuItemStatus.Pending"
            [id]="'income-analysis'" [groupId]="'services'">
          </menu-item>
        </ul>
      </li>
      <li
        [hidden]="!featurePermissions.isFeesEnabled || isCompanyPulseProcessing || disabledTpoAppMenuItems?.includes('Fees')"
        (click)="onListItemClicked($event, 'fees')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'fees'}">
        <a [routerLink]="[basePath + '/fees']">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <span>Fees</span></a>
      </li>
      <li [hidden]="!isManualPricingEntryAvailable || disabledTpoAppMenuItems?.includes('Pricing')"
        (click)="onListItemClicked($event, 'pricing')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'pricing'}">
        <a [routerLink]="[basePath + '/edit-pricing']">
          <i class="status-indicator pi pi-lock-open" style="color: orange"> </i>
          <span>Pricing</span></a>
      </li>
      @let isPricingMenuActive = activeMenuId === 'pricing';
      <li class="tpo-parent-menu-item has-section-toggle"
        [ngClass]="{'mm-active': tab === 'pricing', 'mm-sub-active': isPricingMenuActive && tab !== 'pricing'}"
        [hidden]="!featurePermissions.pricingEnabled || isManualPricingEntryAvailable || disabledTpoAppMenuItems?.includes('Pricing')">

        <a [routerLink]="[basePath + '/pricing']" (click)="expandMenu('pricing')">
          <span>
            <i class="status-indicator pi pi-lock-open mb-1" style="color: orange"></i>
          </span>
          <span>Pricing</span>
          <i class="ms-auto fa-solid fa-chevron-right text-muted section-toggle-icon" style="font-size: 0.7rem;" [class.is-open]="isPricingExpanded" aria-hidden="true"></i>
        </a>
        <button type="button" class="section-toggle" [attr.aria-expanded]="isPricingExpanded"
          aria-label="Pricing submenu" (click)="toggleMenuExpansion('pricing')"></button>
        <ul class="nav-second-level mm-collapse" aria-expanded="false"
          [ngClass]="{'mm-show': isPricingExpanded}">
          @if(!disabledTpoAppMenuItems?.includes('PricingHistory')){
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'pricing-history'}"
            (click)="onListItemClicked($event, 'pricing-history')">
            <a class="nav-link" [routerLink]="[basePath + '/pricing-history']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Pricing History </span>
            </a>
          </li>
          }
          @if(!disabledTpoAppMenuItems?.includes('PricingScenarios')){

          <li class="nav-item" [ngClass]="{'mm-active': tab === 'application-pricing-scenarios'}"
            (click)="onListItemClicked($event, 'application-pricing-scenarios')">
            <a class="nav-link" [routerLink]="[basePath + '/application-pricing-scenarios']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Pricing Scenarios </span>
            </a>
          </li>
          }
          @if (featurePermissions.isAmortizationTableMenuItemVisible &&
          !disabledTpoAppMenuItems?.includes('AmortizationTable')) {
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'amortization'}"
            (click)="onListItemClicked($event, 'amortization')">
            <a class="nav-link" [routerLink]="[basePath + '/amortization']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Amortization Table </span>
            </a>
          </li>
          }
        </ul>
      </li>
      <li class="tpo-parent-menu-item" (click)="onListItemClicked($event, 'conditions')"
        [hidden]="disabledTpoAppMenuItems?.includes('Conditions')" [ngClass]="{'mm-active': tab === 'conditions'}">
        <a [routerLink]="[basePath + '/conditions']">
          <span>Conditions</span>
        </a>
      </li>
      @if (!tpoSubmitted) {
      <li class="tpo-parent-menu-item submission-menu-item" (click)="onListItemClicked($event, 'submission')"
        [ngClass]="{'mm-active': tab === 'submission'}">
        <a [routerLink]="[basePath + '/submission']">
          <span>Submission</span>
        </a>
      </li>
      }
      @if (showUWDecision && !disabledTpoAppMenuItems?.includes('UWDecision')) {
      <li class="tpo-parent-menu-item" (click)="onListItemClicked($event, 'uwDecision')"
        [ngClass]="{'mm-active': tab === 'uwDecision'}">
        <a [routerLink]="[basePath + '/uw-decision']">
          <span>UW Decision</span>
        </a>
      </li>
      }

      @let isContactsTabActive = activeMenuId === 'contacts';
      <li class="tpo-parent-menu-item has-section-toggle"
        [hidden]="disabledTpoAppMenuItems?.includes('Others')"
        [ngClass]="{'mm-sub-active': isContactsTabActive}">
        <a href="javascript: void(0);" [attr.aria-expanded]="isContactsExpanded" (click)="toggleMenuExpansion('contacts')">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <span>Additional</span>
          <i class="ms-auto fa-solid fa-chevron-right text-muted section-toggle-icon" style="font-size: 0.7rem;" [class.is-open]="isContactsExpanded" aria-hidden="true"></i>
        </a>
        <button type="button" class="section-toggle" [attr.aria-expanded]="isContactsExpanded"
          aria-label="Additional submenu" (click)="toggleMenuExpansion('contacts')"></button>
        <ul class="nav-second-level mm-collapse" style="list-style: none;" aria-expanded="false"
          [ngClass]="{'mm-show': isContactsExpanded}">
          @if (!(isCompanyPRMG && applicationContext?.application?.channel === 'Correspondent') &&
          !disabledTpoAppMenuItems?.includes('ChangeOfCircumstance')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'change-of-circumstance')"
            [ngClass]="{'mm-active': tab === 'change-of-circumstance'}">
            <a class="nav-link" [routerLink]="[basePath + '/change-of-circumstance']">
              Change of Circumstance</a>
          </li>
          }
          @if (!disabledTpoAppMenuItems?.includes('EscalationHistory')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'escalation-history')"
            [ngClass]="{'mm-active': tab === 'escalation-history'}"><a class="nav-link"
              [routerLink]="[basePath + '/escalation-history']">Escalation
              History</a></li>
          }

          <li class="nav-item" (click)="onListItemClicked($event, 'loan-docs-v3')" [ngClass]="{'mm-active': tab === 'loan-docs-v3'}">
            <a class="nav-link" [routerLink]="[basePath + '/loan-docs-v3']"
              [hidden]="disabledTpoAppMenuItems?.includes('LoanDocs')">
              Loan Docs
            </a>
          </li>
          <li class="nav-item" (click)="onListItemClicked($event, 'internal-contacts')"
            [ngClass]="{'mm-active': tab === 'internal-contacts'}"><a class="nav-link"
              [routerLink]="[basePath + '/internal-contacts']"
              [hidden]="disabledTpoAppMenuItems?.includes('InternalContacts')">Internal
              Contacts</a></li>
          @if (isCompanyPulseProcessing && !disabledTpoAppMenuItems?.includes('ExternalContacts')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'external-contacts')"
            [ngClass]="{'mm-active': tab === 'external-contacts'}"><a class="nav-link"
              [routerLink]="[basePath + '/external-contacts']">External
              Contacts</a></li>
          }
          @if(!disabledTpoAppMenuItems?.includes('KeyDates')){
          <li class="nav-item" (click)="onListItemClicked($event, 'key-dates')" [ngClass]="{'mm-active': tab === 'key-dates'}"><a
              class="nav-link" [routerLink]="[basePath + '/key-dates']">Key
              Dates</a></li>
          }
          @if (!disabledTpoAppMenuItems?.includes('LoanActivity')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'loan-activity')" [ngClass]="{'mm-active': tab === 'loan-activity'}">
            <a class="nav-link" [routerLink]="[basePath + '/loan-activity']">Loan
              Activity</a>
          </li>
          }
          <!-- <li class="nav-item"><a class="nav-link" href="javascript: void(0);"><i
            class="fa-regular fa-circle"></i>Email/SMS History</a></li> -->
          <!-- <li class="nav-item"><a class="nav-link" [routerLink]="['/tpo/app-details/' + loanId + '/prequal-detail']"><i class="fa-regular fa-circle"></i>Prequal
          Letter</a></li> -->
        </ul>
      </li>
    </ul>
  </div>
</div>
<!-- end left-sidenav-->
